import send from '../../../utils/fetch'

const state = {
    advertiserStatisticsLeads: [],
    advertiserStatisticsFilters: [],
    advDistribution: []
}

const actions = {
    async GET_ADVERTISER_STATISTIC({ commit, dispatch }, date) {
        try {
            const { data } = await send(`${global.$url.statistic.advertiser}?direction=${date.direction}&start=${date.start}&end=${date.end}`, 'GET')
            commit('SET_ADVERTISER_STATISTIC', data.result)
            return data
        } catch (e) {
        }
    }
}

const mutations = {
    SET_ADVERTISER_STATISTIC(state, data) {
        state.advertiserStatisticsLeads = data.leads
        state.advertiserStatisticsFilters = data.filters
        state.advDistribution = data.advDistribution
    }
}

const getters = {
    advertiserStatisticsLeads: state => state.advertiserStatisticsLeads,
    advertiserStatisticsFilters: state => state.advertiserStatisticsFilters,
    advDistribution: state => state.advDistribution
}

export default {
    state,
    actions,
    mutations,
    getters
}
